import { Outlet, RootRoute, Route, Router, redirect } from "@tanstack/react-router";
import DashboardLayout from "./layouts/appLayout";
import Config from "./screens/config";
import Schedules from "./screens/schedules";
import Login from "./screens/auth/login";
import GoLive from "./screens/goLive";
import Studio from "./screens/studio";
import List from "./screens/list";
import Layout from "antd/es/layout/layout";
import Tools from "./screens/tools";
import LandingPage from "./screens";
import { authorizeApi } from "./api";
import Logs from "./screens/logs";
import BulkApiQueue from "./screens/bulkApiQueue";
import Settings from "./screens/settings";
import NewPlayer from "./screens/newPlayer";
import Report from "./screens/report";
import Homepage from "./screens/homepage";
import PrivacyPolicy from "./screens/privacy-policy";
import ScrollToTop from "./component/homePage/scrollToTop";
// const beforeLoad = async () => {
//   const token = localStorage.getItem("AUTH_TOKEN");
//   if (!token) {
//     throw redirect({
//       to: "/login",
//       search: {
//         redirect: router.state.location.href,
//       },
//     });
//   }
//   loginRequest()
// };

const beforeLoad = async ({ context }) => {
  const token = localStorage.getItem("AUTH_TOKEN");
  if (!token) {
    throw redirect({
      to: "/login",
      search: { redirect: window.location.href },
    });
  }
 authorizeApi();
};

const rootRoute = new RootRoute({
  component: () => (
    <>
    <ScrollToTop/>
     <Layout>
      <DashboardLayout defalutSelectedKey={["1"]}>
        <Outlet />
      </DashboardLayout>
    </Layout></>
   
  ),
});

const homePageRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/",
  component: () => <Homepage />,
});
const privacyRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/privacy-policy",
  component: () => <PrivacyPolicy/>,
});

const loginRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "login",
  component: () => <Login />,
});

// const dashboardRoute = new Route({
//   getParentRoute: () => rootRoute,
//   path: "/",
//   component: (params) => {
//     // if (!isAuthenticated()) {
//     //   return <Login />
//     // }
//     return (
//       <DashboardLayout defalutSelectedKey={["1"]}>
//         <Outlet />
//       </DashboardLayout>
//     )
//   },
// });

const statisticRoute = new Route({
  getParentRoute: () => rootRoute,
  beforeLoad,
  path: "/dashboard",
  component: () => {
    return <LandingPage />;
  },
});

const schedulesRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "schedules",
  beforeLoad,
  component: () => <Schedules />,
});
const logsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "logs",
  component: () => <Logs />,
});

const goLiveRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "go-live",
  beforeLoad,
  component: () => <GoLive />,
});

const studioRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "studio",
  component: () => <Studio />,
});

const listRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "list",
  beforeLoad,
  component: () => <List type=",ytst" />,
});

const youtubeRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "youtube",
  beforeLoad,
  component: () => <List type="yt" />,
});

const liveRoute = new Route({
  getParentRoute: () => studioRoute,
  path: "$slug",
  component: () => <Studio />,
});

const configRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/config",
  beforeLoad,
  component: () => <Config />,
});
const toolsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/tools",
  beforeLoad,
  component: () => <Tools />,
});
const settingsRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/settings",
  beforeLoad,
  component: () => <Settings />,
});
// const queueRoute = new Route({
//   getParentRoute: () => rootRoute,
//   path: "/queue",
//   beforeLoad,
//   component: () => <Queue />,
// });
const playerRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/player",
  beforeLoad,
  component: () => <NewPlayer/>,
});

const reportRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/report",
  beforeLoad,
  component: () => <Report/>,
});
const bulkApiQueueRoute = new Route({
  getParentRoute: () => rootRoute,
  path: "/bulk-api",
  beforeLoad,
  validateSearch: (search: Record<string, unknown>) => ({
    stream_key: (search.stream_key as string) || undefined,
  }),
  component: () => <BulkApiQueue />,
});
// const pollsRoute = new Route({
//   getParentRoute: () => rootRoute,
//   path: "/polls",
//   beforeLoad,
//   component: () => <Polls />,
// });


const routeTree = rootRoute.addChildren([
  studioRoute.addChildren([liveRoute]),
  loginRoute,
  homePageRoute,
  statisticRoute,
  listRoute,
  configRoute,
  schedulesRoute,
  goLiveRoute,
  toolsRoute,
  youtubeRoute,
  logsRoute,
  settingsRoute,
  playerRoute,
  bulkApiQueueRoute,
  reportRoute,
  privacyRoute
  
  // pollsRoute
  // queueRoute
]);

const router = new Router({
  routeTree,
  defaultPreload: "intent",
});

export default router;
